import { render, staticRenderFns } from "./ConversationActionsShortcut.vue?vue&type=template&id=dde4a124&scoped=true"
import script from "./ConversationActionsShortcut.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConversationActionsShortcut.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ConversationActionsShortcut.vue?vue&type=style&index=0&id=dde4a124&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dde4a124",
  null
  
)

export default component.exports